import React from 'react';
import {Field, Form, Formik} from "formik";
import CustomFileUploader from "../../CustomFileUploader";
import CustomTextarea from "../inputs/CustomTextarea";
import YkStatusCheckerPopup from "../../popups/YkStatusCheckerPopup";

import "../forms-styles.scss";
import './textarea-checker.scss';

const OffersCheckerForm = ({
                               type,
                               initialValues,
                               currentValues,
                               emailNotification,
                               setEmailNotification,
                               validate,
                               validateVoluumOfferName,
                               campaignID,
                               campaignIDInput,
                               checkCampaignId,
                               validatecampaignID,
                               voluumOfferName,
                               voluumOfferNameEmtry,
                               checkVoluumOfferName,
                               onSubmit,
                               isLoading,
                               fileLinksList,
                               setFileLinksList,
                               listLengthError,
                               formError,
                               setFormError,
                               fileText
                           }) => {
    return (
    <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}>
        {({errors, touched, values}) => (
            <Form>
                <p className='yk-checker-text'>Enter Voluum Offer Name <span className="required">(required)</span> <span>This text will be added to the current Offer name in Voluum</span></p>
                <Field
                    name="VoluumOfferName"
                    type="text"
                    className={voluumOfferNameEmtry ? 'textInput textInputError' : 'textInput' }
                    value={voluumOfferName || ''} 
                    validate={validateVoluumOfferName}
                    onChange={checkVoluumOfferName}
                    placeholder="Voluum Offer Name"
                />
                {voluumOfferNameEmtry ? <div className="error-text login-error-text">Required</div> : ''}     
                <p className='yk-checker-text'>Enter Campaign ID <span className="required">(optional)</span> <span>Please specify the Campaigns where the offers should be deactivated. If the data is not specified, the changes will be applied to all Campaigns </span>
                    <span>You can add several ids divided by space or comma</span></p>
                <Field
                    name="yourFieldName"
                    type="text"
                    className="textInput"
                    onChange={checkCampaignId} 
                    value={campaignIDInput || ''}
                    validate={validatecampaignID}
                    placeholder="Campaign id"
                />           
                <p className='yk-checker-text'>Please insert the Voluum offer ids you want to close, divided by space, comma or new line</p>
                <CustomTextarea
                    name={'linksList'}
                    validate={validate}
                    value={fileLinksList.length !== 0 ? '' : values.linksList}
                    errors={errors.linksList}
                    touched={touched.linksList}
                    arrLength={fileLinksList.length}
                />
                {listLengthError ? <span className='yk-checker-form-error'>Please use file uploading if you need more than 250 links to check.</span> : null}
                <p className='yk-checker-text'>Or upload a file (max 1 MB) here:</p>
                <p className='yk-checker-text'>{fileText}</p>
                <Field>
                    {() => (
                        <CustomFileUploader
                            type={type}
                            setFileLinksList={setFileLinksList}
                            currentValues={currentValues}
                            setFormError={setFormError}
                        />
                    )}
                </Field>

                <YkStatusCheckerPopup
                    open={emailNotification || false}
                    handleClose={setEmailNotification}
                />
                <button className='blue-btn form-submit' type="submit" disabled={isLoading || formError}>Submit</button>
            </Form>
        )}
    </Formik>
)};

export default OffersCheckerForm;